import {React, styled} from 'common'
import Card from '@mui/material/Card'
import UseDanceCard from 'logic/Dance/UseDanceCard'
import DanceCardContent from './DanceCard/DanceCardContent'
import {isMobile} from 'react-device-detect'

const DanceCard = ({dance}) => {
    const {danceStyle, formattedDate, goToDance, t18Dance} = UseDanceCard(dance)

    return (
        <StyledCard isMobile={isMobile}>
            <DanceCardContent
                dance={dance}
                goToDance={goToDance}
                danceStyle={danceStyle}
                formattedDate={formattedDate}
                t18Dance={t18Dance}
            />
        </StyledCard>
    )
}

export default DanceCard

const StyledCard = styled(Card)`
    cursor: pointer;
    height: 470px;
    width: ${({isMobile}) => (isMobile ? window.innerWidth - 40 : '250')}px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    }
    margin: 10px;
`
